const prod = process.env.NODE_ENV !== "development";
let gatewayUrl = process.env.REACT_APP_GATEWAY_URL;
let accountUrl = process.env.REACT_APP_ACCOUNT_URL;
let authUrl = process.env.REACT_APP_AUTH_URL;
let defaultUrl = process.env.REACT_APP_DEFAULT_REDIRECT_URI;
// if(prod){
//     gatewayUrl = "https://" + document.domain.replace("id-vinet.", "gateway.");
//     authUrl = "https://" + document.domain.replace("id-vinet.", "auth.");
//     accountUrl = "https://" + document.domain;
//     defaultUrl = "https://" + document.domain.replace("id-vinet.", "");
//   }

export const GATEWAY_URL = gatewayUrl;
export const AUTH_URL = authUrl;

export const ACCESS_TOKEN = 'accessToken';

export const DEFAULT_REDIRECT_URI = defaultUrl;
export const OAUTH2_REDIRECT_URI = accountUrl + '/oauth2/redirect'

export const GOOGLE_AUTH_URL = AUTH_URL + '/api/oauth2/authorize/google?redirect_uri=' + OAUTH2_REDIRECT_URI;
export const FACEBOOK_AUTH_URL = AUTH_URL + '/api/oauth2/authorize/facebook?redirect_uri=' + OAUTH2_REDIRECT_URI;
export const GITHUB_AUTH_URL = AUTH_URL + '/api/oauth2/authorize/github?redirect_uri=' + OAUTH2_REDIRECT_URI;
